import { wrapFunctionalComponent } from 'utils/framework';
import {
    mediaQueries, space, colors, gradients
} from 'style/config';
import { Flex } from 'components/ui';
import Chiclet from 'components/Chiclet';
import { isGenAINewUIEnabledWithRCPS } from 'ai/utils/aiBeautyChat';

function ContextualChips({
    chips = [], sendMessage, onChipClick, isDisabled = false, width
}) {
    if (!chips || chips.length === 0) {
        return null;
    }

    const isGenAINewUIEnabled = isGenAINewUIEnabledWithRCPS();

    const handleChipClick = chip => {
        if (isDisabled) {
            return;
        }

        if (onChipClick) {
            onChipClick(chip);
        } else if (sendMessage && chip?.content) {
            sendMessage(chip.content);
        }
    };

    const handleKeyDown = (e, chip) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleChipClick(chip);
        }
    };

    return (
        <Flex
            css={styles.container}
            gap={2}
            role='group'
            aria-label='Contextual suggestions'
            width={[width, '100%']}
            backgroundColor={isGenAINewUIEnabled ? gradients.aiBeautyChat : colors.white}
        >
            {chips.map(chip => {
                return (
                    <Chiclet
                        key={chip?.id}
                        variant='shadow'
                        children={chip?.content}
                        onClick={() => handleChipClick(chip)}
                        css={{
                            ...styles.chiclet,
                            opacity: isDisabled ? 0.5 : 1,
                            cursor: isDisabled ? 'not-allowed' : 'pointer'
                        }}
                        aria-label={`Suggestion: ${chip?.content}`}
                        tabIndex={isDisabled ? -1 : 0}
                        onKeyDown={e => handleKeyDown(e, chip)}
                    />
                );
            })}
        </Flex>
    );
}

const styles = {
    container: {
        flexDirection: 'column',
        flexWrap: 'nowrap',
        alignItems: 'flex-start',
        [mediaQueries.xsMax]: {
            maxWidth: 420,
            marginLeft: -space[4],
            marginBottom: -space[4],
            position: 'static',
            bottom: -space[4],
            left: space[2],
            right: 0,
            padding: space[4],
            flexDirection: 'row',
            overflowY: 'hidden',
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': {
                display: 'none'
            },
            scrollPadding: space[2],
            scrollBehavior: 'smooth',
            zIndex: 1
        }
    },
    chiclet: {
        transition: 'all 0.2s ease',
        flexShrink: 0,
        width: 'auto',
        alignSelf: 'flex-start',
        [mediaQueries.xsMax]: {
            whiteSpace: 'nowrap'
        }
    }
};

export default wrapFunctionalComponent(ContextualChips, 'ContextualChips');
